import React, { useState, useEffect } from "react";
import { render } from "react-dom";
import Highcharts from "highcharts";
import HC_exporting from "highcharts/modules/exporting";
import HighchartsReact from "highcharts-react-official";
import styled from "styled-components";
import Link from "../../Link";

export default function PieChart({ title, pass, amber, fail, onClose, showTitle = false }) {
  const options = createOptions({ title, pass, amber, fail, showTitle });
  return (
    <div onClick={onClose} style={{ height: 200 }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}

const createOptions = ({ title, pass, amber, fail, showTitle }) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      height: 200
    },
    credits: {
      enabled: false
    },
    exporting: {
      buttons: {
        contextButton: {
          menuItems: ["downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"]
        }
      },
      chartOptions: {
        title: {
          text: title
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true
            }
          }
        }
      }
    },
    title: {
      text: showTitle ? title : null,
      style: { color: "#333333", fontSize: "11px" },
      margin: 10
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
    },
    accessibility: {
      point: {
        valueSuffix: "%"
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
          format: "<b>{point.name}</b>: {point.percentage:.1f}% ({point.label})"
        }
      }
    },
    navigation: {
      menuItemStyle: {
        padding: "0.2em 0.5em",
        color: "#333333",
        background: "none",
        fontSize: "8px",
        transition: "background 250ms, color 250ms"
      }
    },
    series: [
      {
        name: "Brands",
        colorByPoint: true,
        data: [
          {
            name: "Pass",
            label: pass,
            y: pass,
            color: "#79ffac"
          },
          {
            name: "Amber",
            label: amber,
            y: amber,
            color: "#ffdba2"
          },
          {
            name: "Failure",
            label: fail,
            y: fail,
            color: "#ffcece"
          }
        ]
      }
    ]
  };
};
